import { stateLabel } from "../state-label";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";

export function verbLabel(
  state: ToolActivityState,
  verbs: { done: string; running: string; failed: string },
  target: string,
): ToolActivity {
  return stateLabel(state, {
    done: `${verbs.done} ${target}`,
    running: `${verbs.running} ${target}`,
    failed: `${verbs.failed} ${target}`,
  });
}
